import { useTranslation } from 'react-i18next'
import React, { useEffect, useMemo } from 'react'

import { Col, Grid } from '../../../../../../packages/kiti/components/structure/Grid'
import { useFormState } from '../../../../../../packages/kiti/components/form/form/FormHandler'
import EditableSentence from '../../EditableSentence'
import FormItem from '../../../../../../packages/kiti/components/form/form/FormItem'
import Modal from '../../../../../../components/structure/Modal'

import SubmitBar from '../../../../../../packages/kiti/components/form/SubmitBar'
import Text, { SmallText, Title } from '../../../../../../packages/kiti/components/presentation/Text'
import FieldsSection from './FieldsSection'
import Separator from '../../../../../../packages/kiti/components/helpers/Separator'

const UpdatePlaceSentence = () => {
  const { t } = useTranslation('triggers')
  const [open, setOpen] = React.useState()
  const { form, handleChangeIn } = useFormState()

  const hasSelectedPlaceType = useMemo(() => {
    return form?.conditions?.find(cnd => {
      return cnd.field === 'place.place_type_id'
    })
  }, [form.conditions])

  useEffect(() => {
    if (!hasSelectedPlaceType) {
      handleChangeIn(['payload', 'field_values'], null)
    }
  }, [handleChangeIn, hasSelectedPlaceType])

  const dataToChange = () => {
    let values = []

    const name = form.payload.name
    if (name) {
      values = values.concat([t('fields.name')])
    }
    if (hasSelectedPlaceType) {
      const filtered =
        form.payload.field_values?.filter(fv => {
          return !!fv.value
        }) || []

      const filteredNames = filtered.map(fv => {
        return fv.field?.name || fv.name
      })

      values = values.concat(filteredNames).join(',')
    }

    if (!values.length) return '_______'
    return values
  }

  return (
    <>
      <Text size="h2">{'com os valores de '}</Text>
      <EditableSentence label={dataToChange()} truncate={20} onClick={() => setOpen(true)} field="payload" />

      <Modal open={open} onClose={() => setOpen(false)} width="42rem">
        <Title size="h5" bold>
          {t('updatePlaceData')}
        </Title>
        <Text size="xsmall">{t('fieldsWithoutValueNotChanged')}</Text>
        <Separator weight={4} />

        <Grid paddingGutter={0.5} wrap>
          <Col width="100%">
            <FormItem label={t('fields.name')} path={['payload', 'name']} />
          </Col>

          {!hasSelectedPlaceType && <Text>{t('addPlaceTypeCondition')}</Text>}

          {hasSelectedPlaceType && (
            <Col width="100%">
              <FieldsSection />
            </Col>
          )}
        </Grid>
        {form.payload__error && <SmallText color="red">{t('fillAtLeastOneField')}</SmallText>}
        <SubmitBar onClick={() => setOpen(false)} />
      </Modal>
    </>
  )
}

export default UpdatePlaceSentence
